var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"blocks",staticStyle:{"background":"#ffffff"},attrs:{"id":"block8"}},[_c('div',{staticClass:"container"},[_c('article',[_c('h2',{staticClass:"title-box"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.content)+"\n\t\t\t")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78078b6a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/blocks/Block8.vue
// module id = 149
// module chunks = 0